import { useState } from "react";
import { TbArrowLeft } from "react-icons/tb";
import { Dialog } from "@mui/material";
import { ModalCloseButton } from "../../../../Components/Molecules/ValutDialog";
import { ContaInternacionalTransferirContent } from "./ContaInternacionalTransferirContent";
import { JURISDICTION } from "../constants";

const MODAL_PAPER_CLASS =
  "!rounded-2xl !shadow-card app-card !m-4 !flex !flex-col !max-h-[90vh] !w-full !max-w-2xl";

export const ContaInternacionalTransferirModal = ({ open, onClose, currencyId }) => {
  const [actions, setActions] = useState(null);

  const handleDialogClose = (_, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      return;
    }
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleDialogClose}
      disableEscapeKeyDown
      fullWidth
      maxWidth="sm"
      scroll="paper"
      PaperProps={{ className: MODAL_PAPER_CLASS }}
    >
      <div className="relative flex min-h-0 flex-1 flex-col">
        <ModalCloseButton onClick={onClose} className="absolute right-3 top-3 z-10" />

        <div className="max-h-[70vh] flex-1 overflow-y-auto px-5 pb-3 pt-5 sm:px-6">
          <h2 className="pr-8 text-lg font-bold text-brand-dark">Transferir</h2>
          <p className="mt-0.5 text-sm text-gray-500">
            Meios disponíveis para sua jurisdição ({JURISDICTION.countryLabel}).
          </p>

          <div className="mt-4">
            <ContaInternacionalTransferirContent
              isActive={open}
              currencyId={currencyId}
              hideActionButton
              onRegisterActions={setActions}
              onClose={onClose}
            />
          </div>
        </div>

        <div className="mt-auto shrink-0 border-t border-gray-100 px-5 pb-5 pt-4 sm:px-6">
          <div
            className={`flex flex-col-reverse gap-2 sm:flex-row sm:items-center ${
              actions?.showBack ? "sm:justify-between" : "sm:justify-end"
            }`}
          >
            {actions?.showBack ? (
              <button
                type="button"
                className="btn-back w-full sm:w-auto"
                onClick={() => actions?.back?.()}
              >
                <TbArrowLeft className="h-4 w-4" />
                Voltar
              </button>
            ) : null}
            <button
              type="button"
              className="btn-primary w-full sm:w-auto"
              onClick={() => actions?.submit?.()}
            >
              {actions?.label ?? "Continuar"}
            </button>
          </div>
        </div>
      </div>
    </Dialog>
  );
};
